document.addEventListener('DOMContentLoaded', function() {
  const searchInput = document.getElementById('recipeindex-search');
  // Find the specific grid of recipes by its new ID.
  const recipeGrid = document.getElementById('RecipeGrid');
  
  // If the search input or the recipe grid don't exist, stop.
  if (!searchInput || !recipeGrid) {
    return;
  }

  // Find all recipe items *inside* the recipe grid.
  const recipeItems = recipeGrid.querySelectorAll('.multicolumn-list__item');

  searchInput.addEventListener('input', function(event) {
    const searchQuery = event.target.value.toLowerCase();

    recipeItems.forEach(function(item) {
      const titleElement = item.querySelector('h2');
      const descriptionElement = item.querySelector('.rte');
      
      const titleText = titleElement ? titleElement.textContent.toLowerCase() : '';
      const descriptionText = descriptionElement ? descriptionElement.textContent.toLowerCase() : '';
      const searchableText = titleText + ' ' + descriptionText;

      // --- DEBUGGING LINE ---
      // This will print the text being searched for each recipe into the browser's console.
      console.log('Searching in:', searchableText);
      
      if (searchableText.includes(searchQuery)) {
        item.style.display = '';
      } else {
        item.style.display = 'none';
      }
    });
  });
});